import { E as Environment, I as ImmutableConfiguration, K as KeyHeaders, a as addKeysToHeadersOverride } from './index-CJIbk9Bv.js';

var config = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get Environment () { return Environment; },
	ImmutableConfiguration: ImmutableConfiguration,
	get KeyHeaders () { return KeyHeaders; },
	addKeysToHeadersOverride: addKeysToHeadersOverride
});

export { config as c };
